var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-container',{staticClass:"pa-0"},[_c('Form',{attrs:{"header":_vm.header,"options":[
      _vm.patientHealthy,
      _vm.physicalExamination,
      _vm.history,
      _vm.medicationLongTerm,
      _vm.specialCare,
      _vm.adlBarthelIndex,
      _vm.complicationRate,
      _vm.needCaregiver
    ],"isReadOnly":_vm.isReadOnly},on:{"update":_vm.updateForm,"submit":_vm.submitForm}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }